import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

interface RootStyleProps {
  textColumn: 'left' | 'right';
}

export const root = ({ textColumn }: RootStyleProps) => css`
  margin-bottom: 56px;
  padding: 0 ${spacing.lg}px;
  color: var(--neutral-black-base);
  display: flex;
  flex-direction: column;
  gap: ${spacing.lg}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      flex-direction: ${textColumn === 'left' ? 'row' : 'row-reverse'};
      align-items: center;
      gap: 40px;
    `,
  )};
`;

export const textContent = css`
  h2,
  h3 {
    ${fonts.PRIMARY_SEMIBOLD.family};
    ${fonts.PRIMARY_SEMIBOLD.weight};
  }

  h2 {
    margin: 0 0 ${spacing.xs}px;
    color: var(--brand-purple-base);
    ${responsiveText.HEADING.SM};
  }

  h3 {
    margin: 0 0 ${spacing.sm}px;
    ${responsiveText.BODY.MD};
  }

  p {
    ${fonts.PRIMARY_REGULAR.family};
    ${fonts.PRIMARY_REGULAR.weight};
    ${responsiveText.BODY.MD};
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      flex: 1 1 0;
      min-width: 0;
    `,
  )};
`;

export const imageContainer = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      flex: 1 1 0;
      min-width: 0;
    `,
  )};
`;

export const singleImage = css`
  > div {
    aspect-ratio: 4 / 3;
  }
`;

export const twoImages = css`
  display: flex;
  column-gap: ${spacing.xs}px;
  align-items: flex-start;

  > div {
    width: 50%;
    aspect-ratio: 3 / 4;
  }
`;

export const threeImages = css`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-areas: 'one one' 'two three';
  grid-column-gap: ${spacing.xs}px;
  grid-row-gap: ${spacing.xs}px;
  align-content: start;

  & > div:nth-child(1) {
    grid-area: one;
    aspect-ratio: 16 / 9;
  }

  & > div:nth-child(2) {
    grid-area: two;
    aspect-ratio: 1 / 1;
  }

  & > div:nth-child(3) {
    grid-area: three;
    aspect-ratio: 1 / 1;
  }
`;

export const image = css`
  display: block;
  border-radius: ${spacing.xs}px;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
